import React, { Component, useEffect } from "react";
import OnetoOneView from "./components/onetooneview/OnetoOneView";
import OnDemandPlaying from "./components/ondemandplaying/OnDemandPlaying";

import agoraElectron from "./agora-electron2";
import virtualPlaying from "./virtual-playing";
import ondemandCamera from "./ondemand-camera";

import audioPlay from "./audioPlay";
import AppRoutes from "./components/self-assesment/routes";
import { AssessmentProvider } from "./components/self-assesment/AssessmentContext";
import { ProgressProvider } from "./components/self-assesment/progressContext";
import MyraAgent from "./components/voice-agent/MyraAgent";
import { InactivityModalManager, RestartPopup } from "./components/self-assesment/SelfAssesment";

import RecoveryService from './services/CrashRecoveryService';

const cameraInstance = new ondemandCamera();
window.ondemandCameraInstance = cameraInstance;

const isElectron = window.isElectron === true || window.isElectron || window["electron"];
const isDeepOpen = !!window.savedDeeplink;

window.checkIsSelf = () => {
  const loadSelf = localStorage.getItem("loadSelf");
  if (loadSelf && window.loadedROM) {
    return JSON.stringify(window.loadedROM);
  }
  return "no";
};

window.audioPlayer = new audioPlay();

new agoraElectron().listenNative();
new virtualPlaying().listenNative();
new ondemandCamera().listenNative();
window.audioPlayer.listenNative();

window.openPopupNative = (url) => {
  window.open(url, "Read", "top=50,left=50,toolbar=false,menubar=false,nodeIntegration=no");
};



class App extends Component {
  state = {hideAssessmentElm: window.disableHomeScreen === true};

  componentDidMount() {
    window.setHideElementsElm = (value) => {
	  window.disableHomeScreen = value;
      this.setState({ hideAssessmentElm: value });
    };

    // Crash Recovery Logic
    window.onload = () => {
      console.log("App: Page fully loaded. Checking for crash recovery...");
        
      if (RecoveryService.wasLastSessionCrash()) {
        console.warn("App: Crash detected. Triggering auto-login...");
        setTimeout(() => {
          console.log("App: 5s delay finished. Triggering auto-login now.");
          this.triggerMemberLogin();
        }, 12000);
      }  
    }

    // Safari & iOS: 'pagehide' is the most reliable event
    window.addEventListener("pagehide", RecoveryService.handleIntentionalExit);
    
    // Chrome, Edge, Firefox: 'beforeunload' is the standard
    window.addEventListener("beforeunload", RecoveryService.handleIntentionalExit);
        
    this.handleVisibility = () => {
      if (document.hidden) {
        RecoveryService.stopStressTest();
      }
    };

    document.addEventListener("visibilitychange", this.handleVisibility);
  };

  componentWillUnmount() {
    RecoveryService.stopHeartbeat(true);
    document.removeEventListener("visibilitychange", this.handleVisibility);
  }
  
  // Login Member Logic
  triggerMemberLogin = () => {
    if (window.preloadAllAudios) window.preloadAllAudios();
    if (window.videoUnlockPlay) window.videoUnlockPlay();
    
    setTimeout(() => {
      const loader = document.getElementById("flutter-loader");
      if (loader) loader.style.display = "flex";
      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";
    }, 100);
  }

  render() {
	const hideAssessmentElm = window.disableHomeScreen === true;
	
    return (
      <div className="App">
        <RestartPopup />
        <MyraAgent />
        {/* ========== NEW: Add Modal Manager ========== */}
        <InactivityModalManager />
        {/* ============================================== */}
        <div id="assesmentDiv" className={isDeepOpen ? "hide" : ""}>
		  {!hideAssessmentElm && (
          <AssessmentProvider>
            <ProgressProvider>{!isElectron && <AppRoutes />}</ProgressProvider>
          </AssessmentProvider> 
		  )}
        </div>
        <OnetoOneView />
        <OnDemandPlaying />
      </div>
    );
  }
}
export default App;
